import type { AdminFile } from '@mds/shared/types/file';

/** The chip colours for a file's state: deleted outranks whatever its upload got to. */
export const statusTone = (file: AdminFile) =>
  file.deletedAt
    ? 'border-hairline bg-ink/[0.05] text-ink-muted'
    : file.uploadStatus === 'ready'
      ? 'border-brand-edge/35 bg-brand-wash text-brand-strong'
      : file.uploadStatus === 'pending'
        ? 'border-warn-edge bg-warn-wash text-warn-text'
        : 'border-danger-edge bg-danger-wash text-danger-text';
